import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FileLockSvg = function FileLockSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 2.249h12.349l5.79 5.791v1.418h-1.395v-.84l-4.973-4.974H3.395v17.21h7.675v1.395H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.605 16.203H22v6.046h-8.837v-6.046h1.395V14.11a3.024 3.024 0 0 1 6.047 0zm-1.396 0V14.11a1.628 1.628 0 1 0-3.255 0v2.093zm-4.65 1.395v3.256h6.046v-3.256z",
    clipRule: "evenodd"
  }));
};
export var FileLock = function FileLock(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FileLockSvg
  }));
};